module.exports = __webpack_public_path__ + "media/images/img-travel-1-faada9f0.jpg";